<template>
	<div class="resources-wrapper">
		<div class="content">
			<div class="search flex-start">
				<img src="@/assets/images/search-icon.png" class="icon" alt="">
				<input type="text" placeholder="有甚么疑问呢？" v-model="keywods" @input="inputChange">
				<div class="search-content" v-if="searchList && searchList.length">
					<div @click="getSeachDetail(item.title)" class="items" v-for="(item) in searchList" :key="item.title">{{
						item.title }}
					</div>
				</div>
			</div>
		</div>
		<div class="header main"> <router-link to="start">新手教学</router-link> > {{ selectedMenu.title }}</div>
		<div class="menu main">
			<div class="sidebar">
				<div v-for="(menu, index) in menus" :key="index">
					<div @click="toggleSubMenu(menu)" class="sidebar-content">
						<div v-if="menu.title" class="title">{{ menu.title }}</div>
						<div class="icon" :class="[menu.expanded === false ? '' : 'active']">
							<img src="@/assets/images/open1.png" alt="" />
						</div>
					</div>
					<div v-if="menu.submenus && menu.expanded">
						<div v-for="(submenu, subIndex) in menu.submenus" :key="subIndex" class="sub-menu">
							<div @click="toggleSubMenu_sub(menu, submenu)">{{ submenu.submenutitle }}</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="ismenu" class="sidebar-con outer">
				<div class="problem">{{ selectedMenu.title }}</div>
				<div class="substance">{{ selectedMenu.substance }}</div>
				<div class="border" v-if="Object.keys(selectedMenu).length !== 0"></div>
				<div v-for="(list, subIndex) in selectedMenu.submenus" :key="subIndex">
					<div class="problem-special">{{ list.submenutitle }}</div>
					<div class="" v-for="(index, subIndex) in list.submenuList" :key="subIndex">
						<div @click="getDetail(index.title)" class="subiexcont underline">{{ index.title }}</div>
					</div>
					<div class="border" v-if="Object.keys(selectedMenu).length !== 0"></div>
				</div>
			</div>

			<div v-if="!ismenu" class="sidebar-con outer  ">
				<div class="problem">{{ detail.title }}</div>
				<div class="substance">{{ selectedMenu.substance }}</div>
				<div class="border" v-if="Object.keys(selectedMenu).length !== 0"></div>
				<div class="substance big-content" v-html="detail.detail">

				</div>
			</div>

		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			keywods: '',
			timer: null,
			searchList: [],
			searchallList: [],
			ismenu: true,
			detail: {},
			menus: [

				{
					title: "频道专员",
					content: "菜单2的内容。",
					expanded: false,
					submenus: [

						{
							title: "直播设定",
							problem: "帐户设定",
							substance: "关于你的LOOPSHOP帐户、网店管理员和初始设定。",
							problem2: "订阅计划",
							problem2List: [
								{ content: "如何升级计划？" },
								{ content: "如何取消月费计划?" },
							],
							problem3: "订阅计划",
							problem3List: [
								{ content: "如何注册帐户并取得店舖网址？" },
								{ content: "如何设定.store域名？?" },
								{ content: "如何更改网舖名称、描述及加入网舖位址？" },
								{ content: "如何设定购买确认年龄声明?" },
							],
							problem4: "资金系统",
							problem4List: [
								{ content: "如何汇出资金记录?" },
								{ content: "如何使用资金系统？" },
							],
						},
					],
				},
				{
					title: "仓务专员",
					content: "菜单3的内容。",
					expanded: false,
				},

			],
			selectedMenu: {},
		};
	},
	methods: {
		selectMenu(menu) {
			if (!menu.submenus) {
				console.log('menu->', menu);
				this.selectedMenu = menu;
			}
		},
		toggleSubMenu(menu) {
			this.ismenu = true
			if (menu.submenus) {
				menu.expanded = !menu.expanded;
				this.selectedMenu = menu;
				console.log('selectmenu', this.selectedMenu);
			}
		},
		toggleSubMenu_sub(menu, submenu) {
			this.ismenu = true
			if (menu.submenus) {
				//menu.expanded = !menu.expanded;
				this.selectedMenu = menu;
				console.log('selectmenu', this.selectedMenu);
			}
		},
		async getMenuList(exmenu) {
			//http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=helplist&sjk=helplist&onemulu=%E9%A0%BB%E9%81%93%E5%B0%88%E5%93%A1 
			let fdata = { do: 'helpmenu', sjk: 'helpsubmenu', orderby: 'id asc', limit: 10 }
			let res = await this.$api.funk(fdata)
			this.menus = res
			console.log(res);
			if (exmenu) {
				this.menus[exmenu].expanded = true;
				this.selectedMenu = this.menus[exmenu];
				console.log('select-menu', this.selectedMenu);
			}
		},
		async getDetail(wztitle) {
			console.log(wztitle);
			this.ismenu = false;
			//http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=helplist&sjk=helplist&onemulu=%E9%A0%BB%E9%81%93%E5%B0%88%E5%93%A1 
			let fdata = { do: 'json', sjk: 'helplist', searchkey: 'title', searchvalue: wztitle }
			let res = await this.$api.funk(fdata)
			console.log(res);
			this.detail = res[0]

		},
		async getSeachDetail(wztitle) {
			console.log(wztitle);
			this.searchList = []
			this.ismenu = false;
			//http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=helplist&sjk=helplist&onemulu=%E9%A0%BB%E9%81%93%E5%B0%88%E5%93%A1 
			let fdata = { do: 'json', sjk: 'helplist', searchkey: 'title', searchvalue: wztitle }
			let res = await this.$api.funk(fdata)
			console.log(res);
			this.detail = res[0]

		},
		inputChange() {
			console.log(this.keywods);
			if (this.keywods) {
				clearTimeout(this.timer)
				this.timer = setTimeout(() => {
					this.search()
				}, 300)
			} else {
				clearTimeout(this.timer)
			}
		},

		search() {

			this.searchList = []
			for (var i = 0; i < this.searchallList.length; i++) {
				//判断数据里面是否有符合输入的内容  不符合返回-1 只需要大于或等于0就是符合
				if (this.searchallList[i].title.indexOf(this.keywods) >= 0) {

					console.log(this.searchallList[i].title)
					//然后把它丢进要展示的数组里面
					this.searchList.push(this.searchallList[i])
					//我这里是必选项为防止用户不选择判断如有数据默认第一个

				}
			}
			console.log('searchlist', this.searchList);
		},

		async getSearchList() {
			//http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=helplist&sjk=helplist&onemulu=%E9%A0%BB%E9%81%93%E5%B0%88%E5%93%A1 
			let fdata = { do: 'searchTitleList', sjk: 'helpsubmenu', orderby: 'id asc', limit: 10 }
			let res = await this.$api.funk(fdata)
			this.searchallList = res
			console.log(res);

		},
	},
	mounted() {

		if (this.$route.query.menu) {
			console.log('menus', this.menus)
			console.log('menus-title', this.menus[1].title)
			console.log('menus-expanded', this.menus[1].expanded)


		}
		if (this.$route.query.wztitle) {
			this.wztitle = this.$route.query.wztitle
			console.log('wztitle', this.wztitle)
			console.log('menus-title', this.menus[1].title)
			console.log('menus-expanded', this.menus[1].expanded)
			this.ismenu = false;
			this.getDetail(this.wztitle)
		}
	},
	created(option) {
		const secondMenu = this.menus[1];
		if (secondMenu.submenus && secondMenu.submenus.length > 0) {
			this.selectedMenu = secondMenu.submenus[0];
		}
		const exmenu = this.$route.query.menu || 1
		this.getMenuList(exmenu)
		this.getSearchList()
	}
};
</script>
<style lang="scss" scoped>
	  .underline:hover {
	    cursor: pointer;
	    text-decoration: underline;
	  }
.resources-wrapper {
	.content {
		width: 100%;
		background: url("~@/assets/images/commerceClassroom-bgs.png") no-repeat center center / 100% 100%;
		position: relative;
		height: 1.8rem;

		.search {
			width: 8.4rem;
			height: 0.72rem;
			background: #fafafa;
			border: 1px solid #999999;
			box-shadow: 0px 0.04rem 0.08rem rgba(0, 0, 0, 0.25);
			border-radius: 0.08rem;
			margin: 0 auto;
			position: absolute;
			left: 0;
			right: 0;
			bottom: -0.36rem;
			padding: 0 0.24rem;
			font-family: "Microsoft YaHei";
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.24rem;
			text-align: left;
			color: #808080;

			.search-content {
				position: absolute;
				top: 0.72rem;
				left: 0;
				width: 100%;
				background: #FAFAFA;
				border: 1px solid #999999;
				border-top: 0;
				border-bottom-left-radius: 0.08rem;
				border-bottom-right-radius: 0.08rem;
				// height: 4rem;
				width: 100%;
				z-index: 90;
				overflow: auto;
				padding: 0.3rem 0.1rem;

				.items {
					width: 100%;
					height: 0.8rem;
					padding: 0 0.2rem;
					line-height: 0.8rem;
					border-bottom: 1px solid #999999;
					cursor: pointer;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}

			input {
				flex: 1;
				background: none;
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.24rem;
				line-height: 0.24rem;
				text-align: left;
				color: #000000;

				&::placeholder {
					color: #808080;
				}
			}

			.icon {
				width: 0.24rem;
				height: 0.24rem;
				display: block;
				margin-right: 0.16rem;

				&.active {
					transform: rotate(-180deg);
				}

				img {
					width: 0.14rem;
					height: 0.08rem;
				}
			}
		}
	}

	.outer {
		height: 650px;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.big-content {
		margin-top: 0.26rem;
		font-family: 'Microsoft YaHei';
		font-style: normal;
		font-weight: 400;
		font-size: 0.12rem;
		line-height: 0.18rem;
		color: #000000;
		width: 80%;
	}

	.header {
		font-family: "Microsoft YaHei";
		font-style: normal;
		font-weight: 400;
		font-size: 0.16rem;
		line-height: 0.16rem;
		padding-top: 0.96rem;
		color: #000000;
	}

	.menu {
		display: flex;
		margin-top: 0.79rem;

		.sidebar {
			background: #f5fafa;
			border-radius: 0.24rem;
			width: 2.9rem;
			min-width: 2.9rem;

			.sidebar-content {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0.21rem 0.24rem 0.21rem 0.2rem;

				.title {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 400;
					font-size: 0.16rem;
					line-height: 0.24rem;
					color: #000000;
					cursor: pointer;
				}

				.icon {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 400;
					font-size: 0.16rem;
					line-height: 0.24rem;
					color: #000000;
					cursor: pointer;
					transition: all .6s;

					&.active {
						transform: rotate(-180deg);
					}


					img {
						width: 0.14rem;
						height: 0.08rem;
					}
				}
			}

			.sub-menu {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.16rem;
				line-height: 0.24rem;
				color: #000000;
				padding: 0.2rem 0.4rem;
				cursor: pointer;

				&:hover {
					background: rgba(245, 250, 250, 0.6);
				}
			}
		}

		.sidebar-con {
			margin-left: 1.5rem;

			.problem {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.4rem;
				line-height: 0.56rem;
				color: #000000;
				margin-bottom: 0.1rem;

			}

			.substance {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.16rem;
				line-height: 0.24rem;
				color: #000000;
			}

			.plan {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.16rem;
				line-height: 0.24rem;
				text-decoration-line: underline;
				color: #000000;
				cursor: pointer;
				padding: 0.20rem 0rem 0.36rem 0rem;
			}

			.border {
				opacity: 0.3;
				border: 1px solid #000000;
				width: 8.4rem;
				margin: 0.4rem 0rem;
			}

			.problem-special {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.32rem;
				color: #000000;
				margin-bottom: 0.24rem;
			}

			.subiexcont {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.16rem;
				line-height: 0.24rem;
				color: #000000;
				margin-bottom: 0.16rem;
			}
		}
	}
}

@media (max-width: 750px) {
	.resources-wrapper .content .search {
		width: 6.8rem;
	}

	.resources-wrapper .menu {
		display: block;
	}

	.resources-wrapper .menu .sidebar {
		display: none;
	}

	.resources-wrapper .menu .sidebar-con {
		margin: 0;
		margin-bottom: 2rem;
	}

	.resources-wrapper .menu .sidebar-con .border {
		width: 100%;
		margin: 0.5rem 0;
	}

	.resources-wrapper .menu .sidebar-con .problem {
		margin-bottom: 0.4rem;
	}

	.resources-wrapper .menu .sidebar-con .problem-special {
		font-size: 0.3rem;
	}

	.big-content {
		margin-top: 0.26rem;
		font-family: 'Microsoft YaHei';
		font-style: normal;
		font-weight: 400;
		font-size: 0.12rem;
		line-height: 0.18rem;
		color: #000000;
		width: 400px;
	}

	.resources-wrapper .header {
		font-size: 0.28rem;
		line-height: 0.28rem;
	}

	.resources-wrapper .menu .sidebar-con .subiexcont {
		font-size: 0.3rem;
		line-height: 0.3rem;
	}

}
</style>